import { gql } from '@apollo/client';
import { SUBREGION_FIELDS } from '@/graphql/queries/subregions';
import { SUBREGION_ZIP_FIELDS } from '@/graphql/queries/subregion_zip_mappings';
import { SUBREGION_CARRIER_FIELDS } from '@/graphql/queries/subregion_carrier_mappings';
import { CARRIER_MAPPING_COLUMNS } from '../constants';

export const INSERT_SUBREGIONS_MANY = gql`
    ${SUBREGION_FIELDS}
    mutation InsertSubregionsMany($subregions: [subregions_insert_input!]!) {
        created: insert_subregions(objects: $subregions) {
            returning {
                ...SubregionFields
            }
        }
    }
`;

export const INSERT_SUBREGIONS_MANY_WITH_CARRIERS = gql`
    ${SUBREGION_FIELDS}
    ${SUBREGION_CARRIER_FIELDS}
    mutation InsertSubregionsMany($subregions: [subregions_insert_input!]!) {
        created: insert_subregions(objects: $subregions) {
            returning {
                ...SubregionFields
                carriers(order_by: [{ is_primary: desc_nulls_last }, { created_at: asc }]) {
                    ...SubregionCarrierFields
                }
            }
        }
    }
`;

export const INSERT_SUBREGION = gql`
    ${SUBREGION_FIELDS}
    mutation InsertSubregion($subregion: subregions_insert_input!) {
        created: insert_subregions_one(object: $subregion) {
            ...SubregionFields
        }
    }
`;

export const INSERT_SUBREGION_WITH_CARRIERS = gql`
    ${SUBREGION_FIELDS}
    ${SUBREGION_CARRIER_FIELDS}
    mutation InsertSubregion($subregion: subregions_insert_input!) {
        created: insert_subregions_one(object: $subregion) {
            ...SubregionFields
            carriers(order_by: [{ is_primary: desc_nulls_last }, { created_at: asc }]) {
                ...SubregionCarrierFields
            }
        }
    }
`;

export const UPDATE_SUBREGION = gql`
    ${SUBREGION_FIELDS}

    mutation UpdateSubregion($update: subregions_set_input, $subregion_id: uuid!) {
        created: update_subregions_by_pk(_set: $update, pk_columns: { subregion_id: $subregion_id }) {
            ...SubregionFields
        }
    }
`;

export const DELETE_SUBREGION = gql`
    mutation DeleteSubregion($subregion_id: uuid!) {
        removed: delete_subregions_by_pk(subregion_id: $subregion_id) {
            subregion_id
        }
    }
`;

export const INSERT_ZIP_MAPPINGS = gql`
    ${SUBREGION_ZIP_FIELDS}

    mutation InsertZipMappings($mappings: [subregion_zip_mappings_insert_input!]!) {
        created: insert_subregion_zip_mappings(
            objects: $mappings
            on_conflict: { constraint: subregion_zip_mappings_subregion_id_zip_key, update_columns: [] }
        ) {
            returning {
                ...SubregionZipFields
            }
        }
    }
`;

export const DELETE_ZIP_MAPPINGS = gql`
    ${SUBREGION_ZIP_FIELDS}

    mutation DeleteZipMappings($mappings: [uuid!]!) {
        removed: delete_subregion_zip_mappings(where: { mapping_id: { _in: $mappings } }) {
            returning {
                ...SubregionZipFields
            }
        }
    }
`;

// The whole panel draft in one request. Hasura runs it as one transaction: all of it lands or none.
// UNIQUE (subregion_id, is_primary) is checked at commit, so moving the primary to another carrier saves here.
// Updates send every column, so on_conflict can't reset one to its default.
export const SAVE_SUBREGION = gql`
    mutation SaveSubregion(
        $subregion_id: uuid!
        $set: subregions_set_input!
        $zips: [subregion_zip_mappings_insert_input!]!
        $zip_ids: [uuid!]!
        $carrier_inserts: [subregion_carrier_mappings_insert_input!]!
        $carrier_updates: [subregion_carrier_mappings_insert_input!]!
        $carrier_ids: [uuid!]!
    ) {
        subregion: update_subregions_by_pk(pk_columns: { subregion_id: $subregion_id }, _set: $set) {
            subregion_id
        }
        added_zips: insert_subregion_zip_mappings(
            objects: $zips
            on_conflict: { constraint: subregion_zip_mappings_subregion_id_zip_key, update_columns: [] }
        ) {
            affected_rows
        }
        removed_zips: delete_subregion_zip_mappings(where: { mapping_id: { _in: $zip_ids } }) {
            affected_rows
        }
        removed_carriers: delete_subregion_carrier_mappings(where: { mapping_id: { _in: $carrier_ids } }) {
            affected_rows
        }
        added_carriers: insert_subregion_carrier_mappings(objects: $carrier_inserts) {
            affected_rows
        }
        updated_carriers: insert_subregion_carrier_mappings(
            objects: $carrier_updates
            on_conflict: {
                constraint: subregion_carrier_mappings_pkey
                update_columns: [${CARRIER_MAPPING_COLUMNS.join(' ')}]
            }
        ) {
            affected_rows
        }
    }
`;
